__turbopack_context__.v({
  "mobileHidden": "SiteFooter-module__QXpeUG__mobileHidden",
});
